'use strict';

var utils = [require('./token'), require('./currency'), require('./date'), require('./distance'), require('./interpolate'), require('./log'), require('./map-number'), require('./math'), require('./string'), require('./domain/news')];
module.exports.distance = require('./distance');
utils.forEach(function (util) {
  Object.assign(module.exports, util);
});